import { useTranslation } from 'react-i18next';
import EmployerLoginForm from '$components/LoginForm/EmployerLoginForm/EmployerLoginForm';
import { Link } from 'react-router-dom';
import Home from '$components/Home/Home';
import RemoteSVG from '$components/RemoteSVG/RemoteSVG';
import { useAppSelector } from '$hooks/use-app-selector.hook';

const EmployerLoginScreen = () => {
  const [t] = useTranslation('global');
  const { logoUrl, displayName } = useAppSelector((state) => state.brand);

  return (
    <Home>
      <div className="w-screen h-screen flex items-center justify-center bg-employer-background font-mulish text-spk-highContrast relative">
        <div className="flex gap-28 relative">
          <div className="absolute left-0 -top-10 flex flex-row gap-3 justify-center">
            {logoUrl && (
              <RemoteSVG svgProps={{ className: 'w-24' }} url={logoUrl} />
            )}
            <div className="flex items-center justify-center w-fit bg-spk-highContrast rounded-md px-1.5">
              <p className="text-sm font-bold text-spk-softBlue110">
                {t('employeeLoginScreen.tag')}
              </p>
            </div>
          </div>
          <div className="flex flex-col gap-4">
            <h1 className="text-5xl font-black m-0">
              {t('employeeLoginScreen.title', { brandName: displayName })}
            </h1>
            <p className="text-spk-mediumContrast">
              {t('login.noAccount')}&nbsp;
              <Link
                to="/client_register"
                className="text-employer-primary font-bold underline"
              >
                {t('employeeLoginScreen.signUp')}
              </Link>
            </p>
          </div>
          <div className="w-fill-available">
            <EmployerLoginForm />
          </div>
        </div>
        <div className="absolute bottom-12">
          <p className="text-spk-mediumContrast">
            {t('login.areYouCandidate')}&nbsp;
            <Link to="/login" className="text-employer-primary font-bold">
              {t('login.loginHere')}
            </Link>
          </p>
        </div>
      </div>
    </Home>
  );
};

export default EmployerLoginScreen;
